import React, { FC } from "react";
import { Breadcrumb, Col, Row, Button } from "antd";

import classes from "./PageHead.module.scss";
import { Link } from "react-router-dom";

export interface PageHeadBreadcrumbsProps {
	path?: string;
	label: string;
}
export interface PageHeadButtonsProps {
	label: string;
	onClick?: () => void;
	active?: boolean;
}

export interface PageHeadProps {
	title: string;
	breadcrumb?: PageHeadBreadcrumbsProps[];
	buttons?: PageHeadButtonsProps[];
}

export const PageHead: FC<PageHeadProps> = ({ title, breadcrumb, buttons }) => {
	return (
		<div className={classes["page-head"]} style={{ height: !!buttons?.length ? "300px" : "215px" }}>
			<div className={"container flex-center flex-direction-column"}>
				<h2 className={"mb-20 fz-40"}>{title}</h2>
				<Breadcrumb separator="-">
					{breadcrumb?.map(({ label, path }, index) => (
						<Breadcrumb.Item key={index}>{path ? <Link to={path}>{label}</Link> : label}</Breadcrumb.Item>
					))}
				</Breadcrumb>

				<Row gutter={[20, 20]} className={"mt-25"} justify={"center"}>
					{buttons?.map(({ active, label, onClick }, index) => (
						<Col key={index}>
							<Button ghost={!active} type={"primary"} shape={"round"} onClick={() => onClick && onClick()} size={"large"}>
								{label}
							</Button>
						</Col>
					))}
				</Row>
			</div>
		</div>
	);
};
